
export default function TestimonialsSection() {
  const testimonials = [
    {
      name: "Dr. Sarah Mitchell",
      title: "Pharmacist, Toronto General Hospital",
      image: "https://public.readdy.ai/ai/img_res/9b4874c31d21acb9d3a4b0a013f1c7bb.jpg",
      quote: "CPVA membership has been invaluable for my professional development. The networking opportunities and continuing education programs have significantly advanced my career in clinical pharmacy."
    },
    {
      name: "Dr. Michael Chen",
      title: "Veterinarian, Vancouver Animal Clinic", 
      image: "https://readdy.ai/api/search-image?query=Professional%20male%20veterinarian%20in%20medical%20scrubs%20smiling%20in%20veterinary%20clinic%2C%20clean%20medical%20background%2C%20animal%20healthcare%20professional%20portrait%20with%20bright%20lighting&width=150&height=150&seq=testimonial2&orientation=squarish",
      quote: "The collaborative approach between pharmacy and veterinary medicine that CPVA promotes has enhanced my practice tremendously. The cross-disciplinary resources are exceptional."
    },
    {
      name: "Lisa Thompson",
      title: "Pet Owner & Health Advocate",
      image: "https://readdy.ai/api/search-image?query=Professional%20woman%20smiling%20in%20modern%20healthcare%20setting%2C%20clean%20medical%20background%2C%20healthcare%20advocate%20portrait%20with%20bright%20lighting%20and%20professional%20appearance&width=150&height=150&seq=testimonial3&orientation=squarish",
      quote: "As a member, I've gained access to incredible health resources for both my family and pets. The advocacy work CPVA does truly makes a difference in our healthcare system."
    },
    {
      name: "Dr. Rachel Patel",
      title: "Clinical Pharmacist, Montreal Children's Hospital",
      image: "https://readdy.ai/api/search-image?query=Professional%20female%20pharmacist%20of%20Indian%20descent%20in%20white%20coat%20smiling%20in%20pediatric%20hospital%20pharmacy%2C%20clean%20medical%20background%2C%20healthcare%20professional%20portrait&width=150&height=150&seq=testimonial4&orientation=squarish",
      quote: "The mentorship program connected me with amazing professionals who guided my transition into pediatric pharmacy. CPVA truly invests in its members' success."
    },
    {
      name: "Dr. James Rodriguez",
      title: "Emergency Veterinarian, Calgary Animal Emergency",
      image: "https://readdy.ai/api/search-image?query=Professional%20male%20veterinarian%20of%20Hispanic%20descent%20in%20medical%20scrubs%20smiling%20in%20emergency%20veterinary%20clinic%2C%20clean%20medical%20background%2C%20animal%20healthcare%20professional%20portrait&width=150&height=150&seq=testimonial5&orientation=squarish",
      quote: "The emergency care protocols and pharmaceutical safety guidelines from CPVA have been crucial in my emergency veterinary practice. The resources are always current and evidence-based."
    },
    {
      name: "Dr. Emily Foster",
      title: "Community Pharmacist, Halifax",
      image: "https://readdy.ai/api/search-image?query=Professional%20female%20pharmacist%20smiling%20in%20community%20pharmacy%20setting%2C%20clean%20medical%20background%2C%20healthcare%20professional%20portrait%20with%20bright%20lighting%20and%20modern%20pharmacy%20interior&width=150&height=150&seq=testimonial6&orientation=squarish",
      quote: "Being part of CPVA has connected me with a community of professionals who share my passion for patient care. The support and resources have been instrumental in my community practice."
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            What Our Members Say
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Hear from professionals who have experienced the benefits of CPVA membership firsthand.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
              <div className="flex items-start space-x-4 mb-4">
                <img 
                  src={testimonial.image} 
                  alt={testimonial.name}
                  className="w-16 h-16 rounded-full object-cover object-top flex-shrink-0"
                />
                <div>
                  <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
                  <p className="text-sm text-gray-600">{testimonial.title}</p>
                </div>
              </div>
              <blockquote className="text-gray-700 italic">
                "{testimonial.quote}"
              </blockquote>
              <div className="flex text-yellow-400 mt-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
